"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrearsSubmissionValidatedSchema = void 0;
var constants_1 = require("@hobt/constants");
var arrears_submission_validated_payload_1 = require("./arrears-submission-validated-payload");
var constants_2 = require("../../constants");
var validationErrorSchema = {
    type: 'object',
    required: ['errorDescription'],
    properties: {
        errorCode: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string or null',
        },
        errorDescription: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string or null',
        },
        fieldName: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string or null',
        },
        insurerFileNumber: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string or null',
        },
        invalidFormatRowCount: {
            type: ['number', 'null'],
            errorMessage: 'Should be a number or null',
        },
        lenderReferenceNumber: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string or null',
        },
        row: {
            type: ['number', 'null'],
            errorMessage: 'Should be a number or null',
        },
    },
};
var reportSchema = {
    type: 'object',
    required: ['arrearsFileID', 'fileSubmissionStatus', 'originalArrearsFileID', 'transitNumber'],
    properties: {
        arrearsFileID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        arrearsFileName: {
            type: 'string',
            minLength: 1,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters',
        },
        fileSubmissionStatus: {
            type: 'number',
            enum: Object.values(arrears_submission_validated_payload_1.FileSubmissionStatus),
            errorMessage: 'Should equate to a valid ArrearsIngestionStatus Enum value',
        },
        originalNumberRecords: {
            type: ['number', 'null'],
            errorMessage: 'Should be a number or null',
        },
        numberRecords: {
            type: ['number', 'null'],
            errorMessage: 'Should be a number or null',
        },
        numberRecordsWithErrors: {
            type: ['number', 'null'],
            errorMessage: 'Should be a number or null',
        },
        originalArrearsFileID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        transitNumber: {
            type: 'string',
            minLength: 5,
            maxLength: 5,
            errorMessage: 'Should be a string with exactly 5 characters',
        },
        validationErrors: {
            type: ['array', 'null'],
            items: validationErrorSchema,
            errorMessage: 'Should be an array of ValidationErrors',
        },
    },
};
exports.arrearsSubmissionValidatedSchema = {
    type: 'object',
    required: [
        'reportingPeriod',
        'status',
        'submissionID',
        'correspondenceLanguageCode',
        'email',
        'lenderName',
        'userId',
        'reports',
    ],
    properties: {
        reportingPeriod: {
            type: 'string',
            format: 'date',
            errorMessage: 'Should follow date format YYYY-MM-DD',
        },
        status: {
            type: 'number',
            enum: Object.values(arrears_submission_validated_payload_1.ArrearsIngestionStatus),
            errorMessage: 'Should equate to a valid ArrearsIngestionStatus Enum value',
        },
        submissionID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        correspondenceLanguageCode: {
            type: 'number',
            enum: Object.values(constants_1.Language),
            errorMessage: 'Should equate to a valid Language Enum value',
        },
        email: {
            type: 'string',
            pattern: '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$',
            minLength: 1,
            maxLength: 80,
            errorMessage: {
                maxLength: 'Should be a string with exactly 80 characters',
                pattern: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_MUST_BE_A_VALID_EMAIL_FORMAT),
            },
        },
        lenderName: {
            type: 'string',
            errorMessage: 'Should be a string',
        },
        userId: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        reports: {
            type: ['array'],
            items: reportSchema,
            minItems: 1,
            maxItems: constants_2.maxFileUploadCount,
            errorMessage: 'Should be an array of Reports',
        },
    },
};
